import { useContext } from "react";
import { AppContext } from "../App";
import Course from "./Course";

function Menu() {
	const { courses } = useContext(AppContext);

	return (
		<div id="menu">
			<div className="scroll-content">
				<div className="menu-categories">
					{courses.map((course, i) => (
						<Course course={course} key={i} />
					))}
				</div>
			</div>
		</div>
	);
}

export default Menu;
